import React from 'react'
import {browserHistory, Route, Router} from 'react-router'
import Modification from './Page/Modification/'
import Add from './Page/Ajout/'
import Recherche from './Page/Recherche/'
import Filtre from './Page/Filtre/'
import Outils from './Page/Outils/'

export default _ =>
  <Router history={browserHistory}>
      {/*<Route path="/crm" component={Dashboard}/>*/}
      <Route path="/crm" component={Recherche}/>
      <Route path="/crm/filtre" component={Filtre}/>
      <Route path="/crm/ajout" component={Add}/>
      <Route path="/crm/outils" component={Outils}/>
      <Route path="/crm/:id" component={Modification}/>
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/CRM/index.js